export default __webpack_public_path__ + "static/media/logo.84182ba4.svg";